import ProjectContactsAPI from '../../api/projectContacts';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getContactsByProject: _state => projectId => {
    return _state.records[projectId] || [];
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { projectId }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ProjectContactsAPI.get(projectId);
      commit('setContacts', { projectId, data });
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, { projectId, contactId, roles }) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await ProjectContactsAPI.create(projectId, {
        contactId,
        roles,
      });
      commit('addContact', { projectId, data });
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async update({ commit }, { projectId, id, roles }) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const { data } = await ProjectContactsAPI.update(projectId, id, { roles });
      commit('updateContact', { projectId, data });
      return data;
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  async delete({ commit }, { projectId, id }) {
    commit('setUIFlag', { isDeleting: true });
    try {
      await ProjectContactsAPI.delete(projectId, id);
      commit('deleteContact', { projectId, id });
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  setContacts($state, { projectId, data }) {
    $state.records = { ...$state.records, [projectId]: data };
  },
  addContact($state, { projectId, data }) {
    const contacts = $state.records[projectId] || [];
    $state.records = { ...$state.records, [projectId]: [...contacts, data] };
  },
  updateContact($state, { projectId, data }) {
    const contacts = $state.records[projectId] || [];
    $state.records = {
      ...$state.records,
      [projectId]: contacts.map(contact =>
        contact.id === data.id ? data : contact
      ),
    };
  },
  deleteContact($state, { projectId, id }) {
    const contacts = $state.records[projectId] || [];
    $state.records = {
      ...$state.records,
      [projectId]: contacts.filter(contact => contact.id !== id),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
